<div class="  lg:col-12">
    <p-fileUpload mode="basic" name="file" url="{{config.getBaseUrl()+'lnd/file/upload?type=ImgUpload'}}"  accept="image/*"
                  [auto]="true" [withCredentials]="true"
                  [maxFileSize]="5000000" (onUpload)="getImgList(imgDV)"></p-fileUpload>
</div>
<div class="lg:col-12" style="height:500px;">
    <p-dataView #imgDV [value]="listUploadFile" [totalRecords]="totalImage" [lazy]="true" (onLazyLoad)="getImgList($event)"
                [paginator]="true" [rows]="12" filterBy="name"
                layout="grid">

        <ng-template let-images pTemplate="gridItem">
            <div class="items">
            <div *ngFor="let img of images" class="img-list-item">
                <p-confirmDialog></p-confirmDialog>
                <div *ngIf="!img.used" style="color:red;cursor: pointer;position: absolute;{{getDirection()=='rtl'?'margin-right: -21px;':'margin-left: -21px;'}}" class="pi pi-trash"
                     (click)="deleteIMG(img.id ,imgDV)" ></div>
                <img style="width: 200px;max-width: 200px;cursor: pointer;" [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +img.uid " [alt]="img.name"
                     (click)="imgSelectable==true ? selectImage(img) : copyToClipboard(config.getBaseUrl()+'lnd/file/get_pic?uid=' +img.uid)" />
                <div class="img-list-detail"  (click)="imgSelectable==true ? selectImage(img) : copyToClipboard(config.getBaseUrl()+'lnd/file/get_pic?uid=' +img.uid)">
                    <div class="img-name">{{img.name}}</div>
                </div>
            </div>
            </div>
        </ng-template>

    </p-dataView>
</div>